'use client'

import { setEnabled } from 'cuelume'
import { useAtomValue } from 'jotai'
import { useEffect } from 'react'

import { soundSettingsAtom } from '@/state/storage'

/**
 * Headless — keeps cuelume's own enabled flag in sync with the user's trade-sound
 * setting. cuelume doesn't read/persist any preference itself (its `play()` calls
 * are no-ops once disabled), so every `play(...)` call site elsewhere in the app
 * can call cuelume directly without re-checking `soundSettingsAtom` locally.
 */
export function SoundSettingsSync() {
  const settings = useAtomValue(soundSettingsAtom)
  useEffect(() => {
    setEnabled(settings.tradeSound)
  }, [settings.tradeSound])
  return null
}
